import React, { FC } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { getRequestParams } from '../../tools/service';

interface Props extends RouteProps {
  component: any;
}

const PrivateRoute: FC<Props> = ({ component: Component, ...rest }) => {
  let token = [] as any
  let masterID = ""
  if (localStorage.getItem("token")) {
    token = getRequestParams() as any
    masterID = localStorage.getItem("masterID") as string
  }
  return(
    <Route {...rest} render={props => token["connectionId"] ? <Component {...props} /> : <Redirect to={`/signin?masterID=${masterID}`} />} />
  );
}

export default PrivateRoute;